<template>
  <ScCard class="address-card">
    <template #header>
      <div class="header">
        <span class="title">
          {{ $t('account.addressId') }}: {{ addressId }}
          <div v-if="address.isDefault">
            <span class="default-address">
              {{ $t('account.default') }}
            </span>
            <ScTooltip
              class="info-tooltip"
            >
              <template #tooltip-trigger>
                <GIcon
                  name="info"
                  stroke="var(--light-grey-500)"
                  size="10px"
                  class="info-icon"
                />
              </template>
              <template #tooltip-text>
                <span
                  v-html="$t('account.defaultAddressTooltip')"
                />
              </template>
            </ScTooltip>
          </div>
        </span>
        <div class="right-wrapper">
          <ScTooltip
            class="info-tooltip"
            placement="left"
            v-if="!!tooltip"
          >
            <template #tooltip-trigger>
              <GIcon
                name="info"
                stroke="var(--dark-grey-500)"
                size="14px"
                class="info-icon"
              />
            </template>
            <template #tooltip-text>
              {{ tooltip }}
            </template>
          </ScTooltip>
          <div
            v-if="editable"
            class="edit-container"
            @click="onEdit"
          >
            <span class="text">
              {{ $t('account.edit') }}
            </span>

            <GIcon
              name="edit"
              stroke="var(--dark-grey-500)"
              size="14px"
              class="edit-icon"
            />
          </div>
        </div>
      </div>
    </template>
    <template #body>
      <div class="texts">
        <span class="title">
          {{ $t('account.address') }}:
        </span>
        <span class="content">
          {{ isNewSellerApi ? fullAddressV2 : fullAddress }}
        </span>
      </div>
    </template>
  </ScCard>
</template>

<script>
import ScCard from '@trendyol/sc-ui-kit/ScCard';
import ScTooltip from '@trendyol/sc-ui-kit/ScTooltip';
import GIcon from '@trendyol-js/grace/core/GIcon';

export default {
  name: 'AddressCard',
  components: { ScCard, ScTooltip, GIcon },
  props: {
    type: {
      type: String,
      default: 'N/A',
    },
    address: {
      type: Object,
      default: () => ({
        id: '',
        address: '',
        city: '',
        country: '',
        district: '',
        postalCode: '',
      }),
    },
    tooltip: {
      type: String,
      default: '',
    },
    editable: {
      type: Boolean,
      default: false,
    },
    totalAddress: {
      type: Number,
      default: 0,
    },
    isNewSellerApi: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    addressId () {
      return this.address.legacyId === undefined || this.address.legacyId === null
        ? this.address.id
        : this.address.legacyId;
    },
    fullAddress () {
      return `${this.address.address || ''} ${this.address.districtName || ''} ${this.address.postalCode || ''} ${this.address.cityName || ''} ${this.address.countryName || ''}`.trim();
    },
    fullAddressV2 () {
      return `${this.address.addressLine || ''} ${this.address.district || ''} ${this.address.postalCode || ''} ${this.address.city || ''} ${this.address.country || ''}`.trim();
    },
  },
  methods: {
    onEdit () {
      this.$emit('edit', {
        address: this.address,
        type: this.type,
        totalAddress: this.totalAddress,
      });
    },
  },
};
</script>
<style scoped lang="scss">
  .address-card{
    margin: 10px;
    width: 400px;

    ::v-deep .sc-card{
      border: 1px solid #d5d9e1;
      box-shadow: none !important;
      height: 100%;
      .sc-card-header{
        background-color: #f1f2f7;
        padding: 15px 20px !important;
        border-bottom: 1px solid #d5d9e1;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        .header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          .right-wrapper {
            display: flex;

            .app-tooltip {
              margin-right: 5px;
              margin-bottom: 5px;
            }
          }
          span.title{
            color: #95a1b5;
            font-size: 14px;
            font-weight: 500;
            display: flex;
          }
          span.default-address{
            font-size: 10px;
            opacity: 0.6;
            margin-left: 8px;
          }
          .info-tooltip {
            & .info-icon {
              margin-left: 5px;
              cursor: pointer;
            }
            & .tooltip-text{
              & .arrow:before{
                border-color: #afbbca !important;;
              }
              & span {
                width: 300px;
                font-size: 12px;
                line-height: initial;
                background: #afbbca !important;;
              }
            }
          }
          .edit-container{
            display: flex;
            align-items: center;
            cursor: pointer;
            .edit-icon{
              margin-left: 10px;
            }
            .text{
              font-size: 14px;
              color: #6e7787;
            }
          }
        }

      }
      .sc-card-body{
        padding: 20px !important;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        .texts{
          display: flex;
          font-size: 14px;
          &:not(:first-child){
            margin-top: 10px;
          }
          .title{
            min-width: 65px;
            color: #495057;
          }
          .content{
            font-weight: 300;
            margin-left: 19px;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #495057;
          }
        }
      }
    }
  }
</style>
